module.exports = __webpack_public_path__ + "static/media/pdf-icon.ba0434a8.svg";